import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPhone, FaEnvelope, FaHeadset, FaQuestionCircle } from 'react-icons/fa';
import RadissonLogo from '../../img/LogoBlancoRadisson.png';
import LOGOEBRO from '../../img/LOGO-EBRO.png';

function Footer() {
  const [footerStyle, setFooterStyle] = useState({
    backgroundColor: '#0d47a1',
    logo: RadissonLogo,
    textColor: 'white'
  });

  const updateFooter = () => {
    const businessUnit = localStorage.getItem('businessUnit');
    if (businessUnit === 'PEBEBRO') {
      setFooterStyle({
        backgroundColor: '#494D55',
        logo: LOGOEBRO,
        textColor: 'white'
      });
    } else {
      setFooterStyle({
        backgroundColor: '#0d47a1',
        logo: RadissonLogo,
        textColor: 'white'
      });
    }
  };

  useEffect(() => {
    updateFooter();
    const interval = setInterval(updateFooter, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <footer style={{ 
      backgroundColor: footerStyle.backgroundColor,
      color: footerStyle.textColor,
      padding: '1.5rem 0',
      borderTop: '1px solid rgba(255,255,255,0.1)',
      boxShadow: '0 -2px 10px rgba(0,0,0,0.1)'
    }}>
      <Container>
        <Row className="align-items-center justify-content-between">
          {/* Logo Column */}
          <Col md={2} sm={3} xs={4} className="mb-3 mb-md-0">
            <img
              src={footerStyle.logo}
              alt="Hotel Logo"
              style={{ 
                maxWidth: '100px',
                height: 'auto',
                filter: 'brightness(0) invert(1)'
              }}
            />
          </Col>

          {/* Support Information */}
          <Col md={8} sm={6} xs={8} className="text-center text-md-start">
            <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-center">
              <div className="mb-2 mb-md-0">
                {/* <h6 className="mb-1 d-flex align-items-center justify-content-center justify-content-md-start">
                  <FaHeadset className="me-2" style={{ fontSize: '1.1rem' }} />
                  <span style={{ fontSize: '0.9rem' }}>Soporte Técnico</span>
                </h6> */}
                <div className="d-flex flex-column flex-md-row align-items-center">
                  <p className="mb-1 mb-md-0 me-md-3" style={{ fontSize: '0.8rem' }}>
                    <FaPhone className="me-1" />
                    <strong>+56 22 498 1800</strong>
                  </p>
                  <p className="mb-0" style={{ fontSize: '0.8rem' }}>
                    <FaEnvelope className="me-1" />
                    <strong>reservas@plazaelbosque.cl</strong>
                  </p>
                </div>
              </div>
              
              <div className="mt-2 mt-md-0">
                <button 
                  className="btn btn-outline-light btn-sm d-flex align-items-center"
                  style={{ fontSize: '0.75rem' }}
                >
                  <FaQuestionCircle className="me-1" />
                  Ayuda
                </button>
              </div>
            </div>
          </Col>
        </Row>

        {/* Copyright */}
        <Row className="mt-3">
          <Col className="text-center">
            <p style={{ 
              fontSize: '0.7rem',
              opacity: 0.8,
              marginBottom: 0
            }}>
              &copy; {new Date().getFullYear()} Hotel Plaza el Bosque Ebro. Todos los derechos reservados.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;